<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div bdFxLayoutAlign="space-between center" class="header">
            <div bdFxFlex="1 1 auto" class="title">Verbrauchsmaterial hinzufügen</div>
            <div bdFxFlex bdFxLayoutAlign="end center" class="cancel">
                <button (click)="onCancelBtnClicked()" type="button">
                    Schließen
                    <bd-fa [name]="'times'"></bd-fa>
                </button>
            </div>
        </div>
        <div class="search-input-container">
            <div class="filter-search-text-input">
                <span class="placeholder" *ngIf="!searchPhrase">
                    <bd-fa [name]="'search'"></bd-fa>
                    <span>Durchsuchen...</span>
                </span>

                <bd-labeled-input [(ngModel)]="searchPhrase"
                                  [name]="'search'"
                                  (ngModelChange)="announceSearchTermChanged($event)">
                </bd-labeled-input>

            </div>
        </div>


        <form class="body">
            <div class="table">
                <div class="table-body">
                    <ng-container *ngFor="let categoryContainer of filteredCategorisedWithParentSupplies">

                        <div class="table-row category" (click)="onCategoryClicked( categoryContainer)">
                            <div class="column-article-cell category">
                                <app-product-label [orderItemContainer]="categoryContainer"
                                                   [showTitle]="false"
                                                   [activateHover]="false">
                                </app-product-label>
                            </div>

                            <div></div>

                            <div class="button-cell">

                                <bd-fa-button [name]="'chevron-up'"
                                              [ngClass]="{'rotate-down':! categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded}">
                                </bd-fa-button>

                            </div>
                        </div>

                        <ng-container *ngIf="categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded">
                            <div class="table-row supply"
                                 *ngFor="let supplyContainer of categoryContainer.supplies">
                                <div class="column-article-cell">
                                    <app-product-label [orderItemContainer]="supplyContainer"></app-product-label>
                                </div>

                                <div class="icon-cell">
                                    <img src="./assets/img/icon_warranty.svg" alt="icon warranty"
                                         *ngIf="isWarranty(supplyContainer)">
                                </div>
                                <div class="button-cell">
                                    <bd-checkbox-rounded [name]="supplyContainer.id+'CheckboxSupplyList_ascm'"
                                                         [(ngModel)]="supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList">
                                    </bd-checkbox-rounded>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="notDeviceCategory?.supplies?.length">
                        <div class="table-row category" (click)="onCategoryClicked( notDeviceCategory, true)">
                            <div class="column-article-cell category">
                                <div>Alle Verbrauchsmaterialien</div>
                            </div>


                            <div class="spinner-cell">
                                <bd-fa-button class="spinner" [name]="'refresh fa-spin'"
                                              *ngIf="isSpinnerVisible">
                                </bd-fa-button>
                            </div>
                            <div class="button-cell">

                                <bd-fa-button [name]="'chevron-up'"
                                              [ngClass]="{'rotate-down':! notDeviceCategory.containerSharedMetadata.isSupplyCategoryExpanded}">
                                </bd-fa-button>

                            </div>
                        </div>

                        <ng-container *ngIf="notDeviceCategory.containerSharedMetadata.isSupplyCategoryExpanded">
                            <div class="table-row supply"
                                 *ngFor="let supplyContainer of notDeviceCategory.supplies">
                                <div class="column-article-cell">
                                    <app-product-label [orderItemContainer]="supplyContainer"></app-product-label>
                                </div>

                                <div class="icon-cell">
                                    <img src="./assets/img/icon_warranty.svg" alt="icon warranty"
                                         *ngIf="isWarranty(supplyContainer)">
                                </div>
                                <div class="button-cell">
                                    <bd-checkbox-rounded [name]="supplyContainer.id+'CheckboxSupplyList_ascm'"
                                                         [(ngModel)]="supplyContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList">
                                    </bd-checkbox-rounded>
                                </div>
                            </div>
                        </ng-container>

                    </ng-container>


                </div>
            </div>
        </form>

        <div class="divider"></div>
        <div class="footer">


            <button class="pr-btn-primary" (click)="onSubmitBtnClicked()" type="button">
                Hinzufügen
            </button>

        </div>

    </div>
</div>
